import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {
    IPaymentDiscountRate
} from "../../../../../../../utils/interfaces/my_documents/fiscal_registry/payment/IPaymentDiscountRate";


const useApiGetDiscountRates = (): UseQueryResult<IPaymentDiscountRate[], CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined): Promise<IPaymentDiscountRate[]> {
        try {
            const response = await get(`/api/company/${company_token}/my_documents/payment/discount_rate`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetDiscountRates"],
        queryFn: () => doGet(selectedCompany?.company_token,),
    })
};

export default useApiGetDiscountRates